<template>
  <v-container class="mt-5 ml-2" fluid>
    <v-row>
      <v-col cols="12">
				<v-card class="shadowCard">
					<v-card-title class="text-subtitle-1">
					  {{ modoSoloAvance ? 'Avance encuesta de ambiente laboral' : 'Encuesta de ambiente laboral' }}
					  <v-spacer></v-spacer>
	      		<v-btn
							v-if="!modoSoloAvance"
							color="teal"
							dark
							class="mr-2"
							small
							tile
							:disabled="!avancePorSucursal.length || cargar"
							@click="dialogAvanceSucursal = true"
						>
							<v-icon left small>mdi-chart-bar</v-icon>
							Avance por sucursal
						</v-btn>
	      		<v-btn
							v-if="!modoSoloAvance"
							color="success"
							dark
							class="mr-2"
							small
							tile
							:disabled="!ciclo || cargar || exportandoExcel"
							@click="exportarExcelReporte()"
						>
							<v-icon small left>mdi-microsoft-excel</v-icon>
							Excel
						</v-btn>
	      		<v-btn
							color="primary"
							dark
							@click="initialize()"
							small
							tile
						>
							Actualizar
						</v-btn>
					</v-card-title>
					<v-card-text >

		      	<v-row>
		      		<v-col cols="12" sm="6" lg="4" xl="3">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo"
                  item-text="ciclo"
                  item-value="id_ciclo"
                  return-object
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
              	<v-radio-group
						      v-model="opEscuela"
						      row
						      hide-details
						      class="mt-0"
						    >
						      <v-radio
						        label="Todo"
						        :value="0"
						      ></v-radio>
						      <v-radio
						        label="Inbi"
						        :value="1"
						      ></v-radio>
						      <v-radio
						        label="Fast"
						        :value="2"
						      ></v-radio>
						    </v-radio-group>
              </v-col>
							<v-col cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="filtroPlantel"
                  :items="planteles"
                  label="Sucursal"
                  item-text="plantel"
                  item-value="id_plantel"
                  :disabled="!ciclo"
                >
                </v-autocomplete>
              </v-col>
		      		<v-spacer></v-spacer>
							<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="pb-0">
			          <v-text-field
			            v-model="search"
			            dense
			            filled
			            label="Buscar"
			            append-icon="mdi-magnify"
			          ></v-text-field>  
			        </v-col>
		      	</v-row>

						<v-row v-if="!modoSoloAvance && !esSoloVistaFaltantes" class="mb-2">
							<v-col cols="12" sm="6" md="4" lg="2">
								<v-card :color="semaforoPromedioGeneral.background" class="pa-3 resumen-card" flat>
									<v-icon :color="semaforoPromedioGeneral.color" size="28" class="mb-1 d-block text-center">mdi-traffic-light</v-icon>
									<div class="d-flex align-center justify-center text-h5 font-weight-bold">
										<v-icon small :color="semaforoPromedioGeneral.color" class="mr-2">mdi-circle</v-icon>
										{{ promedioGeneralDisplay }}
									</div>
									<div class="text-caption text-center">Promedio general</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="2">
								<v-card color="blue lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="blue darken-2" size="28" class="mb-1 d-block text-center">mdi-account-group</v-icon>
									<div class="text-h5 font-weight-bold text-center">{{ porcentajeParticipacionDisplay }}%</div>
									<div class="text-caption text-center">Participación</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="3">
								<v-card color="red lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="red darken-2" size="28" class="mb-1 d-block text-center">mdi-alert-circle</v-icon>
									<div class="text-subtitle-1 font-weight-bold text-center text-truncate">{{ peorPreguntaDisplay }}</div>
									<div class="text-caption text-center">Peor pregunta</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="3">
								<v-card color="green lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="green darken-2" size="28" class="mb-1 d-block text-center">mdi-star-circle</v-icon>
									<div class="text-subtitle-1 font-weight-bold text-center text-truncate">{{ mejorPreguntaDisplay }}</div>
									<div class="text-caption text-center">Mejor pregunta</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="2">
								<v-card color="orange lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="orange darken-2" size="28" class="mb-1 d-block text-center">mdi-map-marker-alert</v-icon>
									<div class="text-subtitle-1 font-weight-bold text-center text-truncate">{{ sucursalCriticaDisplay }}</div>
									<div class="text-caption text-center">Sucursal crítica</div>
								</v-card>
							</v-col>
						</v-row>

		        <v-tabs
		          v-if="!modoSoloAvance"
		          v-model="tab"
		          dense
		          align-with-title
		        >
		          <v-tabs-slider></v-tabs-slider>

		          <v-tab v-if="!esSoloVistaFaltantes">Departamentos</v-tab>
		          <v-tab v-if="!esSoloVistaFaltantes">Escuela</v-tab>
		          <v-tab v-if="!esSoloVistaFaltantes">Comentarios</v-tab>
		          <v-tab>Avance</v-tab>
		          <v-tab>Faltantes</v-tab>
		          <v-tab v-if="!esSoloVistaFaltantes">Preguntas</v-tab>
		        </v-tabs>

		        <v-tabs-items v-if="!modoSoloAvance" v-model="tab">

				      <v-tab-item v-if="!esSoloVistaFaltantes">
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headers1"
						          :items="departamentos"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <v-tab-item v-if="!esSoloVistaFaltantes">
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headersEscuela"
						          :items="escuela"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <v-tab-item v-if="!esSoloVistaFaltantes">
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headersComentario"
						          :items="comentarios"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						          <template v-slot:item.nombre_completo="{ item }">
						            <span class="font-weight-medium">{{ item.nombre_completo || '—' }}</span>
						          </template>
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Avance teachers -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text>
				          	<v-row class="mb-2">
				          		<v-col cols="12" sm="4" md="3">
				          			<v-card color="green lighten-5" class="pa-3 resumen-card" flat>
				          				<div class="text-h6 font-weight-bold text-center green--text text--darken-2">{{ avanceConteo.encuestados }}</div>
				          				<div class="text-caption text-center">Contestaron</div>
				          			</v-card>
				          		</v-col>
				          		<v-col cols="12" sm="4" md="3">
				          			<v-card color="orange lighten-5" class="pa-3 resumen-card" flat>
				          				<div class="text-h6 font-weight-bold text-center orange--text text--darken-3">{{ avanceConteo.pendientes }}</div>
				          				<div class="text-caption text-center">Pendientes</div>
				          			</v-card>
				          		</v-col>
				          		<v-col cols="12" sm="4" md="3">
				          			<v-card color="blue lighten-5" class="pa-3 resumen-card" flat>
				          				<div class="text-h6 font-weight-bold text-center blue--text text--darken-2">{{ avanceConteo.incidencias }}</div>
				          				<div class="text-caption text-center">Con incidencia</div>
				          			</v-card>
				          		</v-col>
				          	</v-row>
						        <v-data-table
						          :headers="headersAvance"
						          :items="avanceTeachersFiltrados"
						          class="elevation-0"
						          dense
						          :search="search"
						          item-key="id_trabajador"
						          no-data-text="Sin teachers activos para el filtro seleccionado"
						        >
						        	<template v-slot:item.encuestado="{ item }">
						        		<v-btn
						        			small
						        			tile
						        			:color="item.encuestado ? 'success' : 'orange darken-1'"
						        			dark
						        			disabled
						        			class="avance-estatus-btn"
						        		>
						        			<v-icon left small>{{ item.encuestado ? 'mdi-check-circle' : 'mdi-clock-outline' }}</v-icon>
						        			{{ item.encuestado ? 'Contestó' : 'Pendiente' }}
						        		</v-btn>
						        	</template>
						        	<template v-slot:item.incidencia="{ item }">
						        		<div v-if="item.encuestado" class="text-caption grey--text">—</div>
						        		<div v-else-if="item.id_incidencia" class="d-flex align-center flex-wrap">
						        			<v-btn
						        				small
						        				tile
						        				color="teal"
						        				dark
						        				@click="abrirIncidencia( item, true )"
						        			>
						        				<v-icon left small>mdi-file-document-check</v-icon>
						        				Ver incidencia
						        			</v-btn>
						        		</div>
						        		<v-btn
						        			v-else
						        			small
						        			tile
						        			outlined
						        			color="orange darken-2"
						        			@click="abrirIncidencia( item, false )"
						        		>
						        			<v-icon left small>mdi-alert-circle-outline</v-icon>
						        			Registrar
						        		</v-btn>
						        	</template>
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <v-tab-item>
				        <v-card flat>
				          <v-card-text class="black--text">
				          	<v-row class="mb-3">
				          		<v-col cols="12" sm="4">
				          			<v-card outlined :color="opEscuela === 1 ? 'blue lighten-5' : ''" flat>
				          				<v-card-text class="py-2">
				          					<div class="text-subtitle-2 font-weight-bold">INBI</div>
				          					<div>Total encuesta: {{ resumenFaltantesEscuela.inbi.total }}</div>
				          					<div>Total ERP: {{ resumenFaltantesEscuela.inbi.total_erp }}</div>
				          					<div>Faltan: {{ resumenFaltantesEscuela.inbi.faltan }}</div>
				          					<div v-if="resumenFaltantesEscuela.inbi.excluidos" class="mt-1">
				          						<div class="text-caption mb-1">Excluidos:</div>
				          						<v-chip
				          							v-for="teacher in teachersExcluidosPorEscuela.inbi"
				          							:key="'ex-inbi-' + teacher.id_trabajador"
				          							x-small
				          							class="mr-1 mb-1"
				          							color="orange lighten-4"
				          						>{{ teacher.nombre_completo }}</v-chip>
				          					</div>
				          					<div>Avance: {{ resumenFaltantesEscuela.inbi.avance }} %</div>
				          				</v-card-text>
				          			</v-card>
				          		</v-col>
				          		<v-col cols="12" sm="4">
				          			<v-card outlined :color="opEscuela === 2 ? 'orange lighten-5' : ''" flat>
				          				<v-card-text class="py-2">
				          					<div class="text-subtitle-2 font-weight-bold">FAST</div>
				          					<div>Total encuesta: {{ resumenFaltantesEscuela.fast.total }}</div>
				          					<div>Total ERP: {{ resumenFaltantesEscuela.fast.total_erp }}</div>
				          					<div>Faltan: {{ resumenFaltantesEscuela.fast.faltan }}</div>
				          					<div v-if="resumenFaltantesEscuela.fast.excluidos" class="mt-1">
				          						<div class="text-caption mb-1">Excluidos:</div>
				          						<v-chip
				          							v-for="teacher in teachersExcluidosPorEscuela.fast"
				          							:key="'ex-fast-' + teacher.id_trabajador"
				          							x-small
				          							class="mr-1 mb-1"
				          							color="orange lighten-4"
				          						>{{ teacher.nombre_completo }}</v-chip>
				          					</div>
				          					<div>Avance: {{ resumenFaltantesEscuela.fast.avance }} %</div>
				          				</v-card-text>
				          			</v-card>
				          		</v-col>
				          		<v-col cols="12" sm="4">
				          			<v-card outlined :color="opEscuela === 0 ? 'grey lighten-4' : ''" flat>
				          				<v-card-text class="py-2">
				          					<div class="text-subtitle-2 font-weight-bold">TODO</div>
				          					<div>Total encuesta: {{ resumenFaltantesEscuela.todo.total }}</div>
				          					<div>Total ERP: {{ resumenFaltantesEscuela.todo.total_erp }}</div>
				          					<div>Faltan: {{ resumenFaltantesEscuela.todo.faltan }}</div>
				          					<div v-if="resumenFaltantesEscuela.todo.excluidos" class="mt-1">
				          						<div class="text-caption mb-1">Excluidos:</div>
				          						<v-chip
				          							v-for="teacher in teachersExcluidosPorEscuela.todo"
				          							:key="'ex-todo-' + teacher.id_trabajador"
				          							x-small
				          							class="mr-1 mb-1"
				          							color="orange lighten-4"
				          						>{{ teacher.nombre_completo }}</v-chip>
				          					</div>
				          					<div>Avance: {{ resumenFaltantesEscuela.todo.avance }} %</div>
				          				</v-card-text>
				          			</v-card>
				          		</v-col>
				          	</v-row>
				          	<v-row>
				          		<v-col cols="12" sm="6" md="4" lg="3">
				          			<v-select
				          				v-model="filtroEstatusSeguimiento"
				          				:items="opcionesEstatusSeguimiento"
				          				label="Estatus"
				          				dense
				          				filled
				          				clearable
				          				hide-details
				          			></v-select>
				          		</v-col>
				          		<v-col cols="12" sm="6" md="8" lg="9" class="d-flex align-center">
				          			<div>
				          				<b>Filtro activo ({{ etiquetaEscuelaActiva }}):</b>
				          				Total teachers: {{ empleados }} ·
				          				Contestaron: {{ conteoSeguimientoContestaron }} ·
				          				Pendientes: {{ conteoSeguimientoPendientes }} ·
				          				Avance: {{ avanceFaltantes }} %
				          			</div>
				          		</v-col>
				          	</v-row>
						        <v-data-table
						          :headers="headersFaltantes"
						          :items="teachersSeguimientoFiltrados"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        	<template v-slot:item.estatus="{ item }">
						        		<v-chip
						        			small
						        			:color="item.estatus === 'Contestó' ? 'green lighten-4' : 'orange lighten-4'"
						        			:text-color="item.estatus === 'Contestó' ? 'green darken-2' : 'orange darken-2'"
						        		>{{ item.estatus }}</v-chip>
						        	</template>
						        	<template v-slot:item.en_sucursal_texto="{ item }">
						        		<div class="en-sucursal-cell">
							        		<v-chip
							        			small
							        			label
							        			class="en-sucursal-chip ma-0"
							        			:color="item.en_sucursal ? 'blue lighten-4' : 'grey lighten-4'"
							        			:text-color="item.en_sucursal ? 'blue darken-3' : 'grey darken-1'"
							        			:title="item.en_sucursal
							        				? `En sucursal — último chequeo ${ item.hora_ultimo_chequeo ? String( item.hora_ultimo_chequeo ).substring( 0, 5 ) : 'hoy' }`
							        				: 'Sin entrada activa hoy (sin chequeo o ya registró salida)'"
							        		>
							        			{{ item.en_sucursal_texto }}
							        		</v-chip>
						        		</div>
						        	</template>
						        	<template v-slot:item.fecha_encuesta="{ item }">
						        		{{ formatearFechaEncuesta( item.fecha_encuesta ) }}
						        	</template>
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <v-tab-item v-if="!esSoloVistaFaltantes">
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headerPreguntas"
						          :items="preguntas"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				    </v-tabs-items>

						<!-- Vista restringida: solo Avance (Recepción / Programador de producto) -->
						<v-card v-if="modoSoloAvance" flat>
							<v-card-text>
								<v-row class="mb-2">
									<v-col cols="12" sm="4" md="3">
										<v-card color="green lighten-5" class="pa-3 resumen-card" flat>
											<div class="text-h6 font-weight-bold text-center green--text text--darken-2">{{ avanceConteo.encuestados }}</div>
											<div class="text-caption text-center">Contestaron</div>
										</v-card>
									</v-col>
									<v-col cols="12" sm="4" md="3">
										<v-card color="orange lighten-5" class="pa-3 resumen-card" flat>
											<div class="text-h6 font-weight-bold text-center orange--text text--darken-3">{{ avanceConteo.pendientes }}</div>
											<div class="text-caption text-center">Pendientes</div>
										</v-card>
									</v-col>
									<v-col cols="12" sm="4" md="3">
										<v-card color="blue lighten-5" class="pa-3 resumen-card" flat>
											<div class="text-h6 font-weight-bold text-center blue--text text--darken-2">{{ avanceConteo.incidencias }}</div>
											<div class="text-caption text-center">Con incidencia</div>
										</v-card>
									</v-col>
								</v-row>
								<v-data-table
									:headers="headersAvance"
									:items="avanceTeachersFiltrados"
									class="elevation-0"
									dense
									:search="search"
									item-key="id_trabajador"
									no-data-text="Sin teachers activos para el filtro seleccionado"
								>
									<template v-slot:item.encuestado="{ item }">
										<v-btn
											small
											tile
											:color="item.encuestado ? 'success' : 'orange darken-1'"
											dark
											disabled
											class="avance-estatus-btn"
										>
											<v-icon left small>{{ item.encuestado ? 'mdi-check-circle' : 'mdi-clock-outline' }}</v-icon>
											{{ item.encuestado ? 'Contestó' : 'Pendiente' }}
										</v-btn>
									</template>
									<template v-slot:item.incidencia="{ item }">
										<div v-if="item.encuestado" class="text-caption grey--text">—</div>
										<div v-else-if="item.id_incidencia">
											<v-btn
												small
												tile
												color="teal"
												dark
												@click="abrirIncidencia( item, true )"
											>
												<v-icon left small>mdi-file-document-check</v-icon>
												Ver incidencia
											</v-btn>
										</div>
										<v-btn
											v-else
											small
											tile
											outlined
											color="orange darken-2"
											@click="abrirIncidencia( item, false )"
										>
											<v-icon left small>mdi-alert-circle-outline</v-icon>
											Registrar
										</v-btn>
									</template>
								</v-data-table>
							</v-card-text>
						</v-card>

		      </v-card-text>
				</v-card> 
			</v-col>
		</v-row>

		<v-dialog v-model="dialogAvanceSucursal" max-width="900px" scrollable>
			<v-card>
				<v-card-title class="text-subtitle-1">
					Avance por sucursal
					<v-spacer></v-spacer>
					<v-btn
						color="success"
						dark
						small
						:disabled="!avancePorSucursal.length"
						@click="exportarExcelAvanceSucursal()"
					>
						<v-icon small left>mdi-microsoft-excel</v-icon>
						Excel
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-data-table
						:headers="headersAvanceSucursal"
						:items="avancePorSucursal"
						class="elevation-0"
						dense
						hide-default-footer
						:items-per-page="-1"
					>
						<template v-slot:item.avance="{ item }">
							{{ formatearNumero( item.avance ) }} %
						</template>
					</v-data-table>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="dialogAvanceSucursal = false">Cerrar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogIncidencia" max-width="560px" persistent scrollable>
			<v-card>
				<v-card-title class="text-subtitle-1">
					{{ incidenciaSoloLectura ? 'Incidencia registrada' : 'Registrar incidencia' }}
					<v-spacer></v-spacer>
					<v-btn icon small @click="cerrarIncidencia()"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-card-text v-if="teacherIncidencia">
					<div class="mb-3">
						<div class="font-weight-medium">{{ teacherIncidencia.nombre_completo }}</div>
						<div class="text-caption">{{ teacherIncidencia.plantel }} · {{ teacherIncidencia.escuela }}</div>
					</div>
					<v-textarea
						v-model="formIncidencia.comentario"
						filled
						dense
						hide-details
						label="Motivo / comentario"
						:readonly="incidenciaSoloLectura"
						rows="3"
						class="mb-3"
					></v-textarea>
					<div v-if="!incidenciaSoloLectura">
						<v-file-input
							v-model="formIncidencia.archivo"
							filled
							dense
							hide-details
							accept="image/png, image/jpeg, image/bmp, image/webp"
							prepend-icon="mdi-camera"
							label="Evidencia (1 imagen)"
							@change="previsualizarIncidencia()"
						></v-file-input>
						<v-card v-if="formIncidencia.preview" class="mt-3 pa-2" flat outlined>
							<v-img :src="formIncidencia.preview" contain max-height="220"></v-img>
						</v-card>
					</div>
					<div v-else-if="formIncidencia.evidenciaUrl">
						<div class="text-caption mb-1">Evidencia</div>
						<v-card class="pa-2" flat outlined>
							<v-img :src="formIncidencia.evidenciaUrl" contain max-height="220" @click="dialogImagenIncidencia = true" style="cursor:pointer"></v-img>
						</v-card>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="cerrarIncidencia()">Cerrar</v-btn>
					<v-btn
						v-if="!incidenciaSoloLectura"
						color="success"
						dark
						tile
						small
						:loading="guardandoIncidencia"
						:disabled="!puedeGuardarIncidencia"
						@click="guardarIncidencia()"
					>
						Guardar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogImagenIncidencia" max-width="900px">
			<v-card v-if="formIncidencia.evidenciaUrl">
				<v-img :src="formIncidencia.evidenciaUrl" contain max-height="80vh"></v-img>
			</v-card>
		</v-dialog>

		<!-- Dialog de carga -->
		<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
		<carga                v-if="cargar"/>

	</v-container>
</template>

<script>
	import axios from 'axios'
	import { mapGetters } from 'vuex'
	import XLSX                 from 'xlsx'
	import Alerta                from '@/components/alertas/Alerta.vue'
	import carga                 from '@/components/alertas/carga.vue';
	import validarErrores       from '@/mixins/validarErrores'
	import funcionesExcel       from '@/mixins/funcionesExcel'

	const PUESTOS_SOLO_AVANCE_AMBIENTE = [19, 52]

	export default {
		components:{
			Alerta,
			carga,
		},

		mixins: [ validarErrores, funcionesExcel ],

		data: () => ({
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      headers1: [
        { text: 'Departamento'    , value: 'departamento'        },
        { text: 'Promedio'        , value: 'promedio'            }, 
      ],

      headersComentarioBase: [
      	{ text: 'Pregunta'          , value: 'pregunta'           },
        { text: 'Comentario'        , value: 'comentario'         },
      ],
      
	  headerPreguntas:[
      	{ text: 'Tema'             , value: 'pregunta'           },
      	{ text: 'Pregunta'         , value: 'subtitulo'          },
        { text: 'Promedio'         , value: 'promedio'           },
        { text: 'Respuestas'       , value: 'respuestas'         },
      ],

      headersFaltantes:[
      	{ text: 'Escuela'        , value: 'escuela'           },
      	{ text: 'Nombre'         , value: 'nombre_completo'   },
      	{ text: 'Estatus'        , value: 'estatus'           },
      	{ text: 'En sucursal'    , value: 'en_sucursal_texto', width: '120px', align: 'center', sortable: false },
      	{ text: 'Fecha encuesta' , value: 'fecha_encuesta'    },
      	{ text: 'Puesto'         , value: 'puesto'            },  
      	{ text: 'Departamento'   , value: 'departamento'      },  
      	{ text: 'Plantel'        , value: 'plantel'           },  
      	{ text: 'Jefe'           , value: 'jefe'              },  
      ],

      headersAvance: [
      	{ text: 'Plantel'      , value: 'plantel'           },
      	{ text: 'Teacher'      , value: 'nombre_completo'   },
      	{ text: 'Escuela'      , value: 'escuela'           },
      	{ text: 'Encuesta'     , value: 'encuestado'        , sortable: false, align: 'center', width: '140px' },
      	{ text: 'Incidencia'   , value: 'incidencia'        , sortable: false, align: 'center', width: '160px' },
      ],

      headersAvanceSucursal: [
      	{ text: 'Sucursal'     , value: 'plantel'     },
      	{ text: 'Total'        , value: 'total'       , align: 'end' },
      	{ text: 'Encuestados'  , value: 'encuestados' , align: 'end' },
      	{ text: 'Faltan'       , value: 'faltan'      , align: 'end' },
      	{ text: 'Avance (%)'   , value: 'avance'      , align: 'end' },
      ],

      headersEscuela: [
        { text: 'Escuela'         , value: 'escuela'             },  
        { text: 'Promedio'        , value: 'promedio'            },  
      ],

			search:'',
      data:[],

      tab: 0,
			ciclos:[],
      ciclo:null,
      faltantes:[],
			teachersSeguimiento: [],
			avanceTeachers: [],
			dialogIncidencia: false,
			dialogImagenIncidencia: false,
			incidenciaSoloLectura: false,
			teacherIncidencia: null,
			guardandoIncidencia: false,
			urlEvidencia: '',
			formIncidencia: {
				comentario: '',
				archivo: null,
				preview: '',
				evidenciaUrl: '',
			},
			filtroEstatusSeguimiento: null,
			opcionesEstatusSeguimiento: [
				{ text: 'Todos', value: null },
				{ text: 'Contestó', value: 'Contestó' },
				{ text: 'Pendiente', value: 'Pendiente' },
			],
			comentarios:[],
			escuela:[],
			departamentos:[],
			empleados: 0,
			preguntas: [],
			opEscuela: 0,
			planteles: [],
			filtroPlantel: null,
			resumenFaltantesEscuela: {
				inbi: { total: 0, total_erp: 0, faltan: 0, excluidos: 0, avance: '0.00' },
				fast: { total: 0, total_erp: 0, faltan: 0, excluidos: 0, avance: '0.00' },
				todo: { total: 0, total_erp: 0, faltan: 0, excluidos: 0, avance: '0.00' },
			},
			teachersExcluidosPorEscuela: {
				inbi: [],
				fast: [],
				todo: [],
			},
			resumen:{
				promedio_general: 0,
				respuestas_obtenidas: 0,
				empleados_encuestados: 0,
				total_empleados: 0,
				porcentaje_participacion: 0,
				peor_pregunta: null,
				mejor_pregunta: null,
				sucursal_critica: null,
			},
			dialogAvanceSucursal: false,
			exportandoExcel: false,
		}),

		computed: {

			...mapGetters( 'login' ,['getdatosUsuarioERPERP']),

			esSoloVistaFaltantes () {
				const idpuesto = Number( this.getdatosUsuarioERPERP.idpuesto )
				return idpuesto === 82
			},

			modoSoloAvance () {
				const idpuesto = Number( this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto )
				return PUESTOS_SOLO_AVANCE_AMBIENTE.includes( idpuesto )
			},

			puedeVerAutorComentario () {
				const iderp = Number( this.getdatosUsuarioERPERP.iderp )
				return [1, 334, 568].includes( iderp )
			},

			headersComentario () {
				const headers = [...this.headersComentarioBase]
				if ( this.puedeVerAutorComentario ) {
					headers.push({ text: 'Realizado por', value: 'nombre_completo' })
				}
				return headers
			},

			promedioGeneralNumero () {
				return Number( this.resumen.promedio_general ) || 0
			},

			promedioGeneralDisplay () {
				return this.formatearNumero( this.promedioGeneralNumero )
			},

			porcentajeParticipacionDisplay () {
				return this.formatearNumero( this.resumen.porcentaje_participacion )
			},

			semaforoPromedioGeneral () {
				return this.semaforoPromedio( this.promedioGeneralNumero )
			},

			peorPreguntaDisplay () {
				return this.resumenPregunta( this.resumen.peor_pregunta )
			},

			mejorPreguntaDisplay () {
				return this.resumenPregunta( this.resumen.mejor_pregunta )
			},

			sucursalCriticaDisplay () {
				return this.resumenConPromedio( this.resumen.sucursal_critica, 'plantel' )
			},

			avanceFaltantes () {
				const lista = this.teachersSeguimientoActivos
				const total = lista.length
				if ( !total ) return '0.00'
				const pendientes = lista.filter( t => t.estatus === 'Pendiente' ).length
				return ( ( ( total - pendientes ) / total ) * 100 ).toFixed( 2 )
			},

			etiquetaEscuelaActiva () {
				if ( this.opEscuela === 1 ) return 'INBI'
				if ( this.opEscuela === 2 ) return 'FAST'
				return 'TODO'
			},

			teachersSeguimientoActivos () {
				return this.filtrarTeachersPorEscuela( this.teachersSeguimiento )
			},

			teachersSeguimientoFiltrados () {
				let lista = this.teachersSeguimientoActivos
				if ( this.filtroEstatusSeguimiento ) {
					lista = lista.filter( t => t.estatus === this.filtroEstatusSeguimiento )
				}
				return lista
			},

			conteoSeguimientoContestaron () {
				return this.teachersSeguimientoActivos.filter( t => t.estatus === 'Contestó' ).length
			},

			conteoSeguimientoPendientes () {
				return this.teachersSeguimientoActivos.filter( t => t.estatus === 'Pendiente' ).length
			},

			avanceTeachersFiltrados () {
				return this.filtrarTeachersPorEscuela( this.avanceTeachers )
			},

			avanceConteo () {
				const lista = this.avanceTeachersFiltrados
				const encuestados = lista.filter( t => Number( t.encuestado ) === 1 ).length
				const pendientes = lista.filter( t => Number( t.encuestado ) !== 1 ).length
				const incidencias = lista.filter( t => t.id_incidencia ).length
				return { encuestados, pendientes, incidencias }
			},

			puedeGuardarIncidencia () {
				return !!(
					this.formIncidencia.comentario
					&& this.formIncidencia.comentario.trim()
					&& this.formIncidencia.archivo
					&& !this.guardandoIncidencia
				)
			},

			avancePorSucursal () {
				const porPlantel = new Map()
				for ( const teacher of this.avanceTeachersFiltrados ) {
					const plantel = teacher.plantel || 'Sin plantel'
					if ( !porPlantel.has( plantel ) ) {
						porPlantel.set( plantel, { plantel, total: 0, faltan: 0 } )
					}
					const row = porPlantel.get( plantel )
					row.total += 1
					if ( Number( teacher.encuestado ) !== 1 ) row.faltan += 1
				}
				return Array.from( porPlantel.values() ).map( row => {
					const encuestados = Math.max( row.total - row.faltan, 0 )
					const avance = row.total
						? Number( ( ( encuestados / row.total ) * 100 ).toFixed( 2 ) )
						: 0
					return { ...row, encuestados, avance }
				} ).sort( ( a, b ) => String( a.plantel ).localeCompare( String( b.plantel ) ) )
			},

		},

		watch: {
			ciclo( value ){
				if( value != null && value !== '' ){ this.initialize() }
			},

			opEscuela () {
				if( this.ciclo ){ this.initialize() }
			},

			filtroPlantel () {
				if( this.ciclo ){ this.initialize() }
			}
		},

		async created () {
    	await this.getCiclos()
			this.urlEvidencia = axios.defaults.baseURL + 'evidencia-tickets/'
			if ( this.modoSoloAvance || this.esSoloVistaFaltantes ) {
				this.tab = 0
			}
		},

		methods:{

			formatearNumero ( valor ) {
				const numero = Number( valor )
				if ( !Number.isFinite( numero ) ) return '0.00'
				return numero.toFixed( 2 )
			},

			semaforoPromedio ( valor ) {
				const promedio = Number( valor )
				if ( !Number.isFinite( promedio ) || promedio <= 0 ) {
					return { color: 'grey', background: 'grey lighten-4', label: 'Sin datos' }
				}
				if ( promedio < 8 ) return { color: 'red', background: 'red lighten-5', label: 'Rojo' }
				if ( promedio < 9 ) return { color: 'amber darken-2', background: 'amber lighten-5', label: 'Amarillo' }
				return { color: 'green', background: 'green lighten-5', label: 'Verde' }
			},

			resumenConPromedio ( item, campo ) {
				if ( !item || !item[campo] ) return 'Sin datos'
				return `${ item[campo] } (${ this.formatearNumero( item.promedio ) })`
			},

			resumenPregunta ( item ) {
				if ( !item ) return 'Sin datos'
				const texto = item.subtitulo || item.pregunta
				if ( !texto ) return 'Sin datos'
				return `${ texto } (${ this.formatearNumero( item.promedio ) })`
			},

			resumenFaltantesEscuelaDefault () {
				return {
					inbi: { total: 0, total_erp: 0, faltan: 0, excluidos: 0, avance: '0.00' },
					fast: { total: 0, total_erp: 0, faltan: 0, excluidos: 0, avance: '0.00' },
					todo: { total: 0, total_erp: 0, faltan: 0, excluidos: 0, avance: '0.00' },
				}
			},

			resumenDefault () {
				return {
					promedio_general: 0,
					respuestas_obtenidas: 0,
					empleados_encuestados: 0,
					total_empleados: 0,
					porcentaje_participacion: 0,
					peor_pregunta: null,
					mejor_pregunta: null,
					sucursal_critica: null,
				}
			},

			idCicloEncuestaSeleccionado () {
				const c = this.ciclo
				if ( c == null || c === '' ) return null
				if ( typeof c === 'number' ) return Number.isFinite( c ) && c > 0 ? c : null
				const idInbi = Number( c.id_ciclo )
				return Number.isFinite( idInbi ) && idInbi > 0 ? idInbi : null
			},

   		getCiclos () {
      	this.cargar = true
        this.ciclos = []
        return this.$http.get('ciclos.activos.erp').then(response=>{
        	this.ciclos = response.data.filter( el => !el.ciclo.match('FE') && !el.ciclo.match('INVER') && !el.ciclo.match('CAMBIOS') && !el.ciclo.match('EXCI') )
        	this.cargar      = false
        }).catch( error =>{
          const msg = ( error.response && error.response.data && error.response.data.message ) || error.message || 'Error al cargar ciclos'
          this.validarError( msg )
        }).finally( () => { this.cargar = false })
      },

			filtrarTeachersActivos ( items ) {
				return ( items || [] ).filter( item => {
					const puesto = item.id_puesto != null && item.id_puesto !== ''
						? item.id_puesto
						: item.idpuesto
					return Number( puesto ) === 10
				} )
			},

			filtrarTeachersPorEscuela ( items ) {
				let lista = this.filtrarTeachersActivos( items )
				if ( this.opEscuela === 1 ) {
					lista = lista.filter( t => String( t.escuela || '' ).toUpperCase() === 'INBI' )
				} else if ( this.opEscuela === 2 ) {
					lista = lista.filter( t => String( t.escuela || '' ).toUpperCase() === 'FAST' )
				}
				return lista
			},

			formatearFechaEncuesta ( fecha ) {
				if ( !fecha ) return '—'
				const d = new Date( fecha )
				if ( Number.isNaN( d.getTime() ) ) return fecha
				return d.toLocaleDateString( 'es-MX', { year: 'numeric', month: '2-digit', day: '2-digit' } )
			},

			exportarExcelAvanceSucursal () {
				if ( !this.avancePorSucursal.length ) return
				const datos = this.avancePorSucursal.map( row => ( {
					Sucursal: row.plantel,
					Total: row.total,
					Encuestados: row.encuestados,
					Faltan: row.faltan,
					'Avance (%)': this.formatearNumero( row.avance ),
				} ) )
				const ciclo = this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : 'ciclo'
				const escuela = this.etiquetaEscuelaActiva
				const nombreArchivo = `avance_ambiente_sucursal_${ escuela }_${ ciclo }`.replace( /[\\/:*?"<>|]/g, '_' )
				this.exportExcel( datos, nombreArchivo )
			},

			mapearDatosExcel ( headers, items ) {
				return ( items || [] ).map( item => {
					return headers.reduce( ( row, header ) => {
						row[ header.text ] = this.valorExcel( item[ header.value ], header.value )
						return row
					}, {} )
				} )
			},

			valorExcel ( valor, campo ) {
				if ( valor == null ) return ''
				if ( campo === 'promedio' || campo === 'avance' ) {
					if ( String( valor ).toLowerCase() === 'no aplica' ) return 'No aplica'
					const numero = Number( valor )
					return Number.isFinite( numero ) ? numero : valor
				}
				if ( campo === 'encuestado' ) {
					return Number( valor ) === 1 ? 'Contestó' : 'Pendiente'
				}
				return valor
			},

			filtrarTeachersPorEscuelaValor ( items, opEscuela ) {
				let lista = this.filtrarTeachersActivos( items )
				if ( opEscuela === 1 ) {
					lista = lista.filter( t => String( t.escuela || '' ).toUpperCase() === 'INBI' )
				} else if ( opEscuela === 2 ) {
					lista = lista.filter( t => String( t.escuela || '' ).toUpperCase() === 'FAST' )
				}
				return lista
			},

			calcularAvancePorSucursal ( avanceTeachers ) {
				const porPlantel = new Map()
				for ( const teacher of avanceTeachers || [] ) {
					const plantel = teacher.plantel || 'Sin plantel'
					if ( !porPlantel.has( plantel ) ) {
						porPlantel.set( plantel, { plantel, total: 0, faltan: 0 } )
					}
					const row = porPlantel.get( plantel )
					row.total += 1
					if ( Number( teacher.encuestado ) !== 1 ) row.faltan += 1
				}
				return Array.from( porPlantel.values() ).map( row => {
					const encuestados = Math.max( row.total - row.faltan, 0 )
					const avance = row.total
						? Number( ( ( encuestados / row.total ) * 100 ).toFixed( 2 ) )
						: 0
					return { ...row, encuestados, avance }
				} ).sort( ( a, b ) => String( a.plantel ).localeCompare( String( b.plantel ) ) )
			},

			normalizarPayloadAmbiente ( data, opEscuela ) {
				const d = data || {}
				const avanceTeachers = this.filtrarTeachersPorEscuelaValor( d.avanceTeachers || [], opEscuela )
					.map( row => ( {
						...row,
						encuestado: Number( row.encuestado ) === 1 ? 1 : 0,
					} ) )
				const teachersSeguimiento = this.filtrarTeachersPorEscuelaValor( d.teachers_seguimiento || [], opEscuela )
				const faltantes = this.filtrarTeachersPorEscuelaValor( d.faltantes || [], opEscuela )
				const empleados = this.filtrarTeachersPorEscuelaValor( d.empleados || [], opEscuela )
				const resumen = Object.assign( this.resumenDefault(), d.resumen || {} )
				const avanceSucursal = this.calcularAvancePorSucursal( avanceTeachers )
				const totalSeg = teachersSeguimiento.length
				const pendientes = teachersSeguimiento.filter( t => t.estatus === 'Pendiente' ).length
				const avancePct = totalSeg
					? ( ( ( totalSeg - pendientes ) / totalSeg ) * 100 ).toFixed( 2 )
					: '0.00'

				return {
					resumen,
					departamentos: Array.isArray( d.departamentos ) ? d.departamentos : [],
					escuela: Array.isArray( d.escuela ) ? d.escuela : [],
					comentarios: Array.isArray( d.comentarios ) ? d.comentarios : [],
					avanceTeachers,
					teachersSeguimiento,
					faltantes,
					preguntas: Array.isArray( d.preguntas ) ? d.preguntas : [],
					avanceSucursal,
					empleados: empleados.length,
					avancePct,
				}
			},

			hojasExcelEscuela ( etiqueta, datos ) {
				const headersAvanceExcel = [
					{ text: 'Plantel', value: 'plantel' },
					{ text: 'Teacher', value: 'nombre_completo' },
					{ text: 'Escuela', value: 'escuela' },
					{ text: 'Encuesta', value: 'encuestado' },
					{ text: 'Tiene incidencia', value: 'id_incidencia' },
					{ text: 'Comentario incidencia', value: 'incidencia_comentario' },
				]

				const avanceRows = ( datos.avanceTeachers || [] ).map( t => ( {
					...t,
					id_incidencia: t.id_incidencia ? 'Sí' : 'No',
				} ) )

				return [
					{
						nombre: `${etiqueta} Resumen`.slice( 0, 31 ),
						datos: [ {
							Ciclo: this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : '',
							Escuela: etiqueta,
							'Sucursal filtro': this.filtroPlantel
								? ( ( this.planteles.find( p => Number( p.id_plantel ) === Number( this.filtroPlantel ) ) || {} ).plantel || this.filtroPlantel )
								: 'Todas',
							'Promedio general': this.formatearNumero( datos.resumen.promedio_general ),
							'Participación (%)': this.formatearNumero( datos.resumen.porcentaje_participacion ),
							'Peor pregunta': this.resumenPregunta( datos.resumen.peor_pregunta ),
							'Mejor pregunta': this.resumenPregunta( datos.resumen.mejor_pregunta ),
							'Sucursal crítica': this.resumenConPromedio( datos.resumen.sucursal_critica, 'plantel' ),
							'Respuestas obtenidas': datos.resumen.respuestas_obtenidas,
							'Total teachers': datos.empleados,
							Faltan: ( datos.teachersSeguimiento || [] ).filter( t => t.estatus === 'Pendiente' ).length,
							'Avance (%)': datos.avancePct,
						} ],
					},
					{
						nombre: `${etiqueta} Departamentos`.slice( 0, 31 ),
						headers: this.headers1,
						datos: this.mapearDatosExcel( this.headers1, datos.departamentos ),
					},
					{
						nombre: `${etiqueta} Escuela`.slice( 0, 31 ),
						headers: this.headersEscuela,
						datos: this.mapearDatosExcel( this.headersEscuela, datos.escuela ),
					},
					{
						nombre: `${etiqueta} Comentarios`.slice( 0, 31 ),
						headers: this.headersComentario,
						datos: this.mapearDatosExcel( this.headersComentario, datos.comentarios ),
					},
					{
						nombre: `${etiqueta} Avance`.slice( 0, 31 ),
						headers: headersAvanceExcel,
						datos: this.mapearDatosExcel( headersAvanceExcel, avanceRows ),
					},
					{
						nombre: `${etiqueta} Faltantes`.slice( 0, 31 ),
						headers: this.headersFaltantes,
						datos: this.mapearDatosExcel( this.headersFaltantes, datos.teachersSeguimiento ),
					},
					{
						nombre: `${etiqueta} Avance sucursal`.slice( 0, 31 ),
						headers: this.headersAvanceSucursal,
						datos: this.mapearDatosExcel( this.headersAvanceSucursal, datos.avanceSucursal ),
					},
					{
						nombre: `${etiqueta} Preguntas`.slice( 0, 31 ),
						headers: this.headerPreguntas,
						datos: this.mapearDatosExcel( this.headerPreguntas, datos.preguntas ),
					},
				]
			},

			async exportarExcelReporte () {
				const idCiclo = this.idCicloEncuestaSeleccionado()
				if ( idCiclo == null ) {
					this.validarErrorDirecto( 'Selecciona un ciclo válido (id de ciclo no disponible).' )
					return
				}

				this.exportandoExcel = true
				this.cargar = true
				try {
					const basePayload = {
						id_ciclo: idCiclo,
						iderp: this.getdatosUsuarioERPERP.iderp,
						idpuesto: this.getdatosUsuarioERPERP.idpuesto,
						id_plantel: this.filtroPlantel || null,
					}

					const [ resInbi, resFast ] = await Promise.all( [
						this.$http.post( 'encuestas.ambiente.resultados', { ...basePayload, op_escuela: 1 } ),
						this.$http.post( 'encuestas.ambiente.resultados', { ...basePayload, op_escuela: 2 } ),
					] )

					const datosInbi = this.normalizarPayloadAmbiente( resInbi.data, 1 )
					const datosFast = this.normalizarPayloadAmbiente( resFast.data, 2 )

					const workbook = XLSX.utils.book_new()
					const hojas = []
						.concat( this.hojasExcelEscuela( 'INBI', datosInbi ) )
						.concat( this.hojasExcelEscuela( 'FAST', datosFast ) )

					const tieneDatos = hojas.some( h => ( h.datos || [] ).length )
					if ( !tieneDatos ) {
						this.validarErrorDirecto( 'No hay datos para exportar.' )
						return
					}

					hojas.forEach( hoja => {
						const headers = hoja.headers ? hoja.headers.map( header => header.text ) : null
						const sheet = headers
							? XLSX.utils.json_to_sheet( hoja.datos.length ? hoja.datos : [ {} ], { header: headers } )
							: XLSX.utils.json_to_sheet( hoja.datos.length ? hoja.datos : [ {} ] )
						XLSX.utils.book_append_sheet( workbook, sheet, hoja.nombre )
					} )

					const ciclo = this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : 'sin_ciclo'
					const nombreArchivo = `reporte_ambiente_INBI_FAST_${ ciclo }`.replace( /[\\/:*?"<>|]/g, '_' )
					XLSX.writeFile( workbook, `${ nombreArchivo }.xls` )
				} catch ( error ) {
					const msg = ( error.response && error.response.data && error.response.data.message )
						|| error.message
						|| 'Error al exportar Excel'
					this.validarError( msg )
				} finally {
					this.exportandoExcel = false
					this.cargar = false
				}
			},

			initialize ( ) {
				const idCiclo = this.idCicloEncuestaSeleccionado()
				if ( idCiclo == null ) {
					this.validarErrorDirecto( 'Selecciona un ciclo válido (id de ciclo no disponible).' )
					return
				}
				this.cargar = true
				const payload = {
					id_ciclo   : idCiclo,
					iderp      : this.getdatosUsuarioERPERP.iderp,
					idpuesto   : this.getdatosUsuarioERPERP.idpuesto,
					op_escuela : this.opEscuela,
					id_plantel : this.filtroPlantel || null,
				}

				this.$http.post('encuestas.ambiente.resultados', payload).then(response=>{
					const d = response.data || {}
					const empleadosTeachers = this.filtrarTeachersPorEscuela( d.empleados )
					this.faltantes     = this.filtrarTeachersPorEscuela( d.faltantes )
					this.teachersSeguimiento = this.filtrarTeachersPorEscuela( d.teachers_seguimiento )
					this.avanceTeachers = this.filtrarTeachersPorEscuela( d.avanceTeachers || [] ).map( row => ( {
						...row,
						encuestado: Number( row.encuestado ) === 1 ? 1 : 0,
					} ) )
					this.comentarios   = Array.isArray( d.comentarios ) ? d.comentarios : []
					this.escuela       = Array.isArray( d.escuela ) ? d.escuela : []
					this.departamentos = Array.isArray( d.departamentos ) ? d.departamentos : []
					this.empleados     = empleadosTeachers.length
					this.preguntas     = Array.isArray( d.preguntas ) ? d.preguntas : []
					this.planteles     = Array.isArray( d.planteles ) ? d.planteles : []
					this.resumen       = Object.assign( this.resumenDefault(), d.resumen || {} )
					const rfe = d.resumen_faltantes_escuela || {}
					const rfeDefault = this.resumenFaltantesEscuelaDefault()
					this.resumenFaltantesEscuela = {
						inbi: Object.assign( {}, rfeDefault.inbi, rfe.inbi || {} ),
						fast: Object.assign( {}, rfeDefault.fast, rfe.fast || {} ),
						todo: Object.assign( {}, rfeDefault.todo, rfe.todo || {} ),
					}
					const tpe = d.teachers_excluidos_por_escuela || {}
					const excluidosFallback = Array.isArray( d.teachers_excluidos ) ? d.teachers_excluidos : []
					this.teachersExcluidosPorEscuela = {
						inbi: Array.isArray( tpe.inbi ) ? tpe.inbi : [],
						fast: Array.isArray( tpe.fast ) ? tpe.fast : [],
						todo: Array.isArray( tpe.todo ) ? tpe.todo : excluidosFallback,
					}
					if ( !tpe.todo && !tpe.inbi && !tpe.fast && excluidosFallback.length ) {
						this.teachersExcluidosPorEscuela.todo = excluidosFallback
					}
				}).catch( error =>{
					const msg = ( error.response && error.response.data && error.response.data.message ) || error.message || 'Error al cargar el reporte'
					this.validarError( msg )
				}).finally( () => { this.cargar = false })	
			},

			abrirIncidencia ( item, soloLectura ) {
				this.teacherIncidencia = item
				this.incidenciaSoloLectura = soloLectura
				this.formIncidencia = {
					comentario: item.incidencia_comentario || '',
					archivo: null,
					preview: '',
					evidenciaUrl: item.incidencia_evidencia
						? this.urlEvidencia + item.incidencia_evidencia
						: '',
				}
				this.dialogIncidencia = true
			},

			cerrarIncidencia () {
				this.dialogIncidencia = false
				this.teacherIncidencia = null
				this.incidenciaSoloLectura = false
				this.formIncidencia = {
					comentario: '',
					archivo: null,
					preview: '',
					evidenciaUrl: '',
				}
			},

			previsualizarIncidencia () {
				const archivo = this.formIncidencia.archivo
				if ( !archivo ) {
					this.formIncidencia.preview = ''
					return
				}
				if ( archivo.size > 26214400 ) {
					this.validarErrorDirecto( 'El archivo sobrepasa el límite de peso, máx. 25 MB' )
					this.formIncidencia.archivo = null
					this.formIncidencia.preview = ''
					return
				}
				const reader = new FileReader()
				reader.onload = ( e ) => {
					this.formIncidencia.preview = e.target.result
				}
				reader.readAsDataURL( archivo )
			},

			subirEvidenciaIncidencia () {
				const formData = new FormData()
				formData.append( 'file', this.formIncidencia.archivo )
				return this.$http.post( 'tickets.subir.evidencia', formData ).then( response => {
					const nombres = Array.isArray( response.data ) ? response.data : []
					if ( !nombres.length ) {
						throw new Error( 'No se pudo subir la evidencia' )
					}
					return nombres[0]
				} )
			},

			async guardarIncidencia () {
				if ( !this.puedeGuardarIncidencia || !this.teacherIncidencia ) return
				const idCiclo = this.idCicloEncuestaSeleccionado()
				if ( idCiclo == null ) {
					this.validarErrorDirecto( 'Selecciona un ciclo válido.' )
					return
				}
				this.guardandoIncidencia = true
				try {
					const evidencia = await this.subirEvidenciaIncidencia()
					const payload = {
						id_ciclo: idCiclo,
						id_trabajador: this.teacherIncidencia.id_trabajador,
						comentario: this.formIncidencia.comentario.trim(),
						evidencia,
						id_usuario: this.getdatosUsuarioERPERP.iderp,
					}
					const response = await this.$http.post( 'encuestas.ambiente.incidencia.add', payload )
					const inc = response.data && response.data.incidencia ? response.data.incidencia : null
					const idx = this.avanceTeachers.findIndex(
						t => Number( t.id_trabajador ) === Number( this.teacherIncidencia.id_trabajador )
					)
					if ( idx >= 0 && inc ) {
						this.$set( this.avanceTeachers, idx, {
							...this.avanceTeachers[idx],
							id_incidencia: inc.id_incidencia,
							incidencia_comentario: inc.comentario,
							incidencia_evidencia: inc.evidencia,
							incidencia_fecha: inc.fecha_registro,
						} )
					}
					this.validarSuccess( response.data.message || 'Incidencia registrada' )
					this.cerrarIncidencia()
				} catch ( error ) {
					const msg = ( error.response && error.response.data && error.response.data.message )
						|| error.message
						|| 'Error al guardar la incidencia'
					this.validarError( msg )
				} finally {
					this.guardandoIncidencia = false
				}
			},
    }
	}
</script>

<style scoped>
.en-sucursal-cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

.en-sucursal-chip {
  font-size: 0.75rem !important;
  font-weight: 600;
  min-width: 40px;
  justify-content: center;
}

.avance-estatus-btn.v-btn--disabled {
  opacity: 1 !important;
}
</style>
